<template>
  <div class="container">
    <img src="@/assets/img/successIcon.png" alt="" />
    <h2>审批成功</h2>
  </div>
</template>
<script>
export default {
  name: 'Home'
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';

.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 240px;
    height: 240px;
    margin-top: 240px;
  }

  h2 {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 56px;
    margin-top: 20px;
  }
}
</style>
